// Formats date as MMMM dd, yyyy
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(
    date
  );
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day < 10 ? `0${day}` : day}, ${year}`;
};

/**
 * Format date to Oct 24, 2023 (US),
 * Format date to 2023年10月24日 (CN)
 */
export function formatDate1(dateString, region) {
  const date = new Date(dateString);

  let locale = 'en-US';

  if(region.toUpperCase() === 'CN') {
    locale = 'zh-CN';
  }

  return date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
}

/*
format time string from date
*/
export const formatTime = (value) => {
  const formater = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });

  // 9:31 am
  return formater.format(value).toLocaleLowerCase();
};
// will parse time format string and replace time part of time,
// time format 14:48  for 24 hours ,  1:48 am, 1:48 pm
export const combineDateAndTime = (str, date = new Date()) => {

  if (str.match(/^(\d{1,2}:\d{1,2})+( ([AaPp][Mm]))*/)) {
    // ["1", "48", "am"]
    const arr = str.split(/:| /);

    if (arr.length !== 2 && arr.length !== 3) {
      throw new Error('Bad Time Format');
    }

    let hour = parseInt(arr[0], 10);
    const minute = parseInt(arr[1], 10);

    if (hour < 0) throw new Error('Bad Time Format');

    if (arr.length === 3) {

      // am pm format
      if (arr[2].toLowerCase() === 'pm') {
        if (hour === 0 || hour > 12) throw new Error('Bad Time Format');
        // 12:00 pm = 12:00
        if (hour < 12) hour = hour + 12;
      } else {
        // am
        if (hour > 12) throw new Error('Bad Time Format');
        // 12:00 am = 00:00
        if (hour === 12) hour = 0;
      }
    }


    if (minute > 59 || minute < 0) throw new Error('Bad Time Format');


    date.setHours(hour);
    date.setMinutes(minute);

    return date;
  } throw new Error('Bad Time Format');
};

// Formats date as yyyy-MM-dd with CN locale
export const formatDateCN = (dateString) => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${year}-${month < 10 ? `0${month}` : month}-${
    day < 10 ? `0${day}` : day
  }`;
};

const sameDay = (dateOne, dateTwo, timeZone) => {
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    month: '2-digit',
    day: 'numeric',
    year: 'numeric',
  });

  const dateOneParts = dateFormatter.format(dateOne).split('/');
  const dateTwoParts = dateFormatter.format(dateTwo).split('/');

  return (
    dateOneParts[0] === dateTwoParts[0] &&
    dateOneParts[1] === dateTwoParts[1] &&
    dateOneParts[2] === dateTwoParts[2]
  );
};

// Format date: 'ddd, MMMM D, YYYY'
// Format time: 'LT' - 'LT z'
export const getEventDateInfo = (startDateString, endDateString, timeZone) => {
  const start = startDateString ? new Date(startDateString) : new Date();
  const end = endDateString ? new Date(endDateString) : new Date();
  const compare = startDateString ? new Date(startDateString) : new Date();

  const locale = 'en-US';

  const options = {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  const startTimeFormatter = new Intl.DateTimeFormat(locale, options);
  const endTimeFormatter = new Intl.DateTimeFormat(locale, {
    ...options,
    timeZoneName: 'short',
  });
  const dateFormatter = new Intl.DateTimeFormat(locale, {
    timeZone,
    weekday: 'short',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const startDate = dateFormatter.format(start);
  const startTime = startTimeFormatter.format(start);
  const startTimeWithTZ = endTimeFormatter.format(start);
  const endDate = dateFormatter.format(end);
  const endTime = endTimeFormatter.format(end);

  // Compare start time and end time of the startDate
  compare.setHours(end.getHours());
  compare.setMinutes(end.getMinutes());

  // Duration in hours
  const duration = `${(compare - start) / (60 * 60 * 1000)}`;

  const isSameDay = sameDay(start, end, timeZone);

  return {
    startDate,
    startTime,
    startTimeWithTZ,
    endDate,
    endTime,
    duration,
    isSameDay,
  };
};

// Format date:  'dddd YYYY-MM-DD'
// Format time: 'LT'
export const getEventDateInfoCN = (
  startDateString,
  endDateString,
  timeZone
) => {
  const start = startDateString ? new Date(startDateString) : new Date();
  const end = endDateString ? new Date(endDateString) : new Date();
  const compare = startDateString ? new Date(startDateString) : new Date();

  const locale = 'zh-CN';

  const weekdayFormatter = new Intl.DateTimeFormat(locale, {
    timeZone,
    weekday: 'long',
  });
  // Using 'en-US' to prevent CN characters - we just want the raw numbers
  const monthFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    month: '2-digit',
  });
  const dayFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    day: '2-digit',
  });
  const yearFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
  });
  const timeFormatter = new Intl.DateTimeFormat(locale, {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: false,
  });

  const sweekday = weekdayFormatter.format(start);
  const smonth = monthFormatter.format(start);
  const sday = dayFormatter.format(start);
  const syear = yearFormatter.format(start);

  const eweekday = weekdayFormatter.format(end);
  const emonth = monthFormatter.format(end);
  const eday = dayFormatter.format(end);
  const eyear = yearFormatter.format(end);

  const startDate = `${sweekday} ${syear}-${smonth}-${sday}`;
  const startTime = timeFormatter.format(start);
  const endDate = `${eweekday} ${eyear}-${emonth}-${eday}`;
  const endTime = timeFormatter.format(end);

  // Compare start time and end time of the startDate
  compare.setHours(end.getHours());
  compare.setMinutes(end.getMinutes());

  // Duration in hours
  const duration = `${(compare - start) / (60 * 60 * 1000)}`;

  const isSameDay = sameDay(start, end, timeZone);

  return {
    startDate,
    startTime,
    startTimeWithTZ: startTime, // TZ not needed for CN
    endDate,
    endTime,
    duration,
    isSameDay,
  };
};
